/**
 * @license
 * Copyright (c) %FIRST_YEAR% %CURRENT_YEAR%, Oracle and/or its affiliates. All rights reserved.
 * https://www.oracle.com/contracts/docs/cloud_csa_online_v062223_us_eng.pdf?download=false&er=221886
 * @ignore
 */
// DO NOT MODIFY THIS FILE MANUALLY!
// This file is automatically generated based on the corresponding SVG image in
// the packages/oraclejet-preact/resources/icons folder.
import { ComponentProps } from 'preact';
import { Icon } from '../../UNSAFE_Icon';
type Props = Omit<ComponentProps<typeof Icon>, 'viewBox' | 'children'>;
const SvgEarOff = (props: Props) => (
  <Icon viewBox="0 0 24 24" {...props}>
    <g fill="none">
      <g fill="currentcolor">
        <path d="m22.707 21.293-1.414 1.414-5.599-5.599a27.558 27.558 0 0 1-4.013 4.624l-.288.268H8v-2h2.6a25.173 25.173 0 0 0 3.653-4.333l-1.812-1.812c.038.204.059.418.059.645 0 .675-.172 1.248-.48 1.71-.305.458-.704.75-1.073.934a3.457 3.457 0 0 1-1.426.356h-.02l-.002-2h-.01l.026-.001a1.458 1.458 0 0 0 .538-.144.759.759 0 0 0 .302-.253c.067-.1.145-.277.145-.602s-.078-.502-.145-.602a.759.759 0 0 0-.302-.253 1.458 1.458 0 0 0-.538-.144l-.026-.001H8.5V9.914L7.033 8.447A4.858 4.858 0 0 0 7 9H5c0-.625.1-1.411.354-2.231L1.293 2.707l1.414-1.414zM12 2c2.69 0 4.487 1.045 5.586 2.444A6.795 6.795 0 0 1 19 8.5c0 1.116-.36 2.98-1.375 5.21l-1.522-1.522c.67-1.662.897-2.976.897-3.688 0-.738-.25-1.882-.986-2.82C15.313 4.79 14.109 4 12 4c-1.409 0-2.414.388-3.138.948l-1.42-1.42C8.527 2.614 10.018 2 12 2z" />
        <path d="M12 5.5c1.326 0 2.251.575 2.812 1.354.523.727.688 1.57.688 2.146h-2c0-.257-.085-.664-.311-.979-.19-.263-.515-.521-1.189-.521-.203 0-.374.026-.52.066L9.988 6.074c.523-.353 1.19-.574 2.012-.574z" />
      </g>
    </g>
  </Icon>
);
export { SvgEarOff as EarOff };
